import { sprintf } from 'sprintf-js';

/** @deprecated use spft from ./common.ts */
export const spf = (format: string, opts: {
  args?: any[],
} = {}): string => sprintf(format, ...opts.args);
